'use client';

import { EventInfoSecondary } from '@/app_components/Conferences/EventInfoSecondary';
import { Image } from '@/app_components/common/Image';
import { useHandheldTap } from '@/app_lib/hooks/useHandheldTap';
import type { EventsListEvent } from '@/app_lib/types/Conferences';
import { cn } from '@/app_lib/utils/utils';

export const EventTile = ({ event, isPast }: { event: EventsListEvent; isPast: boolean }) => {
  const { ref, tapped, onContainerPointerDown } = useHandheldTap();

  return (
    <div
      className={cn(
        'flex flex-col min-h-0 h-full w-full min-w-0 overflow-hidden max-lg:aspect-square lg:aspect-[4/5] relative isolate group p-xs xl:p-sm rounded-sm ring ring-secondary',
        isPast && 'bg-secondary',
        !isPast && 'hover:[&_*]:text-white data-[active=true]:[&_*]:text-white shadow-md',
      )}
      data-active={tapped}
      data-cy='event-card'
      id={`event-tile-${event.id}`}
      onPointerDown={onContainerPointerDown}
      ref={ref}
    >
      <EventInfoSecondary
        event={event}
        past={isPast}
      />
      {!isPast && (
        <>
          <Image
            alt={event.cardMedia.alt}
            className={cn(
              '-z-2 pointer-events-none rounded-sm object-cover absolute top-0 left-0 w-full h-full opacity-0 transition-opacity duration-300 ease-in-out',
              'group-hover:opacity-100 group-data-[active=true]:opacity-100',
            )}
            data-cy='event-card-image'
            height={450}
            src={event.cardMedia.url}
            width={300}
          />
          <div
            className={cn(
              'pointer-events-none absolute rounded-sm -z-1 top-0 left-0 w-full h-full bg-black opacity-0 transition-opacity duration-300 ease-in-out',
              'group-hover:opacity-50 group-data-[active=true]:opacity-50',
            )}
          />
        </>
      )}
    </div>
  );
};
